/* ApplicationPromoSent */
export const TITLE = '¡Listo! Enviaste la solicitud de promo';
export const SUBTITLE = 'Te avisaremos por mail cuando los bancos estén adheridos y la promo se apruebe.';
export const BUTTON_TEXT = 'Entendido';
